import { Component } from '@theme/component'
import { trapFocus } from '@theme/focus'

/**
 * A custom element that manages the Kiwi Sizing Chart.
 *
 * @typedef {object} KiwiSizingComponentRefs
 * @property {HTMLDivElement} kiwiSizingChart - The Kiwi Sizing Chart element.
 *
 * @extends Component<KiwiSizingComponentRefs>
 */
export class KiwiSizingComponent extends Component {
  requiredRefs = ['kiwiSizingChart']

  /** @type {MutationObserver} */
  #mutationObserver = new MutationObserver(() => {
    const triggerBtn = this.refs.kiwiSizingChart.querySelector(
      '.ks-chart-modal-button'
    )
    if (triggerBtn) {
      triggerBtn.addEventListener('click', this.#handleModalTriggerClick)
    }

    const tableElement =
      this.refs.kiwiSizingChart.querySelector('.ks-table-wrapper')
    if (tableElement) {
      tableElement.setAttribute('tabindex', '0')
    }

    const imageElement =
      this.refs.kiwiSizingChart.querySelector('.ks-image img')
    if (imageElement) {
      imageElement.setAttribute('alt', 'kiwi sizing')
    }

    if (triggerBtn && tableElement && imageElement) {
      this.#mutationObserver.disconnect()
    }
  })

  connectedCallback() {
    super.connectedCallback()
    this.#mutationObserver.observe(this.refs.kiwiSizingChart, {
      childList: true,
      subtree: true,
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.#mutationObserver.disconnect()
  }

  #handleModalTriggerClick = () => {
    /** @type {HTMLElement | null} */
    const modal = document.querySelector('.kiwi-sizing-modal')
    if (!modal) {
      return
    }

    trapFocus(modal)
  }
}

if (!customElements.get('kiwi-sizing-chart')) {
  customElements.define('kiwi-sizing-chart', KiwiSizingComponent)
}
